import adminRequest from 'services/adminRequest';

export function resourcesPutActivityReportComment(token, body, id) {
    const url = `reports/moveV1/${id}`;
    return adminRequest(
        url,
        {
            method: 'PUT',
            data: JSON.stringify(body),
        },
        true,
        token
    );
}
